import React from "react";
import hairBotoxTreatmentImg from "./../../../../../Images/Blog/Hair_Botox_Treatment/Banner.png";

const HairBotoxTreatmentImg = () => {
  return (
    <div className="blogImg-content">
      <img
        src={hairBotoxTreatmentImg}
        alt="hairBotoxTreatmentImg"
        loading="lazy"
      />
    </div>
  );
};

export default HairBotoxTreatmentImg;
